import React from 'react'
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';
import filesize from 'filesize';
import _ from 'lodash';
import Button from '../Button/Button'
import Link from '../Link/Link'
import Abbreviation from '../Abbreviation'

function getProperties (attributes = []) {
  const props = {};

  if (!_.isArray(attributes)) {
    return props;
  }

  attributes.forEach((prop) => {
    const [ key, val ] = prop.trim().split('=');

    if (key && val) {
      props[key] = val;
    }
  })

  return props;
}

function transform(node, index) {
  // do not render any <span> tags
  if (node.type === 'tag' && node.name === 'a') {
    if (!_.isEmpty(_.get('node', 'attribs.type'))) {
      const [ mimeType, ...other ] = _.get(node, 'attribs.type', '').split(';');
      const props = getProperties(other);
      switch (mimeType) {
        case "application/pdf":
          const meta = [];
          meta.push('PDF');
          if (props.length) {
            meta.push(filesize(props.length));
          }
          return <span key={index}>{convertNodeToElement(node, index)} ({meta.join(', ')})</span>;
        default:
          return convertNodeToElement(node, index);
      }
    }
    const props = _.clone(node.attribs);
    if (props['data-anchor']) {
      props['href'] += `#${props['data-anchor']}`
    }

    if (props['class']) {
      props.className = props.class;
      delete props['class'];
    }
    if (props.className && props.className.split(' ').indexOf('button') !== -1) {
      return (
        <Button as="link" {...props} key={index}>
          {node.children && node.children.map(convertNodeToElement)}
        </Button>
      )
    }
    else {
      if (_.find(node.children, { "type": "tag", "name": "img" })) {
        props.className = "no-external"
      }
      return (
        <Link {...props} key={index}>
          {node.children && node.children.map(convertNodeToElement)}
        </Link>
      )
    }
  }
  if (node.type === 'tag' && node.name === 'abbr') {
    return <Abbreviation {...node.attribs} key={index}>
      {node.children && node.children.map(convertNodeToElement)}
    </Abbreviation>
  }
}

const RichText = ({ body }) => ReactHtmlParser(body, { transform })

export default RichText
